import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';

const styles = {
  button: {
    width: '100%',
    fontSize: 14,
    fontWeight: 'bold'
  }
};

const enhance = compose(pure);

const button = enhance(({ classes, onClickAction, href }) => {
  return (
    <Button
      variant="contained"
      color="primary"
      className={classes.button}
      onClick={onClickAction}
      target="_blank"
      href={href}
    >
      店舗さま用お問い合わせ
    </Button>
  );
});

export default withStyles(styles)(button);
